import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import '../../../../css/qavaApp.css';


export function Modal_IngredientList (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [productPicsModal, setProductPicsModal] = useState(false);
    let [checkInModal, setCheckInModal] = useState(false);
    
    let [checkInModal_tracker, setCheckInModal_tracker] = useState(null);
    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    
    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);
    
    useEffect(() => {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientPhoneNumber: cols[4],
                                ingredientAddress: cols[5],
                                ingredientCity: cols[6],
                                ingredientCountry: cols[7],
                                ingredientCostPerUnit: cols[8],
                                ingredientSalePrice: cols[9],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],
                            });
                        });
                    }
                });
    }, []);
    
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }
    
    return (
        <React.Fragment>
                    
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonContent>
            <IonGrid className='appGridContent'>
                            <IonRow>
                                <IonCol size="12">
                                    <h3> Active Orders </h3>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='2'>
                                    <h3> ID </h3>
                                </IonCol>
                                <IonCol size='2'>
                                    <h3> Name </h3>
                                </IonCol>
                                <IonCol size='5'>
                                    <h3> QtyInStock </h3>
                                </IonCol>
                                <IonCol size='3'>
                                    <h3> Action </h3>
                                </IonCol>
                            </IonRow>
                            {viewInventoryAvailableProducts.map((detailData) => {
                                return (
                                    <IonRow key={detailData.ingredientID}>
                                        <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                        <IonCol size='2'>{detailData.ingredientName}</IonCol>
                                        <IonCol size='5'>{detailData.ingredientQtyInStock}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })}
                        </IonGrid>
            </IonContent>
            <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
    
        </React.Fragment>

    )
}